module.exports = __webpack_public_path__ + "img/sponsor_1.bc983167.svg";